import React, { Component, MouseEvent, ReactNode } from 'react';
import Breadcrumb from '../../Breadcrumb';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState, store } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import CustomLoading from '../../custom/CustomLoading';
import NavigationUtil from '../../../util/NavigationUtil';
import { TransactionData, TransactionReason } from '../../../domain/stream/transaction/TransactionDomains';
import { ComponentState, enterComponent, leaveComponent, setSelectedItems } from '../../../redux/actions/ComponentActions';
import ComponentName from '../../../constant/ComponentName';
import { query, repository, subscribe } from '@trlogic/client-js';
import AchService from '../../../service/AchService';
import CollectionNames from '../../../constant/CollectionNames';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import { PageState } from '../../../redux/reducers/PageReducer';
import { changePageFilter, clearPage } from '../../../redux/actions/PageActions';
import CustomTabv2 from '../../custom/CustomTabv2';
import LanguageUtil from '../../../util/LanguageUtil';
import CaseDetailIndicatorPanelComponent from '../../investigation/case/detail/CaseDetailIndicatorPanelComponent';
import CaseDetailSummaryPanelComponent from '../../investigation/case/detail/CaseDetailSummaryPanelComponent';
import CaseDetailChartPanelComponent from '../../investigation/case/detail/CaseDetailChartPanelComponent';
import CaseGraphComponent from '../../graph/CaseGraphComponent';
import AchTransactionsActivityComponent from './AchTransactionsActivityComponent';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import DataType from '../../../constant/DataType';
import {
  AlarmCloseCode,
  CaseChartPanel,
  CaseFieldPanel,
  CaseGraphField,
  CasePanelType,
  CaseSettings,
  CloseCaseBulkActionOperation,
} from '../../../domain/case/CaseDomains';
import DomainConfigurationService from '../../../service/DomainConfigurationService';
import Icon from '../../../icons/Icon';
import { DefaultFilter, User, UserSystemAttributes } from '../../../domain/rbac/RbacDomains';
import { TransactionDataExportJob } from '../../../domain/job/JobDomain';
import moment from 'moment';
import MessageUtil from '../../../util/MessageUtil';
import ValueUtil from '../../../util/ValueUtil';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import CaseAuditComponent from '../../investigation/case/CaseAuditComponent';
import CaseAttachmentContainerComponent from '../../investigation/case/attachment/CaseAttachmentContainerComponent';
import FilterUtil from '../../../util/FilterUtil';
import DefaultFilterUtil from '../../../util/DefaultFilterUtil';
import { assigneeIdFromStoredValue } from '../../../util/CaseAssigneeUtil';
import { canEditCaseDomain } from '../../../util/CasePermissionUtil';
import { canPerformBulkClose } from '../../../util/CaseBulkCloseUtil';
import { changeCaseColumns } from '../../../redux/actions/CaseActions';
import { CaseState } from '../../../redux/reducers/CaseReducer';
import { setAttribute } from '../../../redux/actions/UserActions';
import _ from 'lodash';
import AchDetailVariablePanelComponent from './AchDetailVariablePanelComponent';
import RoleHelper from 'RoleHelper';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import FolderService from '../../../service/FolderService';
import AchDetailHeaderComponent from './AchDetailHeaderComponent';
import { ConfirmPopup } from 'primereact/confirmpopup';
import ItemToolsMenu from '../../ItemToolsMenu';
import eq = query.eq;
import and = query.and;
import or = query.or;
import QueryBuilder = query.QueryBuilder;
import empty = query.empty;
import Filter = query.Filter;
import MatchFilter = query.MatchFilter;
import ConditionalFilter = query.ConditionalFilter;
import Order = query.Order;
import neq = query.neq;
import inside = query.inside;

class AchDetailComponent extends Component<Props, State> {
  public state: State = new State();

  private readonly achService: AchService = ServiceContainer.getInstance().get(ServiceNames.ACH);
  private readonly caseSettingsService: DomainConfigurationService = ServiceContainer.getInstance().get(ServiceNames.DOMAIN_CONFIGURATION);
  private readonly repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  private transactionIntervalId: any;
  private alarmDomainSubscription: subscribe.Subscription | undefined;
  private transactionSubscription: subscribe.Subscription | undefined;
  private ruleSubscription: subscribe.Subscription | undefined;
  private userSubscription: subscribe.Subscription | undefined;
  private logSubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;
  private countUpdateCounter: number = 0;

  public render(): ReactNode {
    const { currentTransaction, loading, commentModalVisible, alarmDomain, users, disabled, scores, commentCount } = this.state;
    const { user } = this.props;

    if (currentTransaction == undefined && loading) {
      return <CustomLoading />;
    }

    if (currentTransaction == undefined) {
      return <div>Transaction not found</div>;
    }

    return (
      <div className={'flex flex-col w-full gap-y-5 h-full'}>
        <ConfirmPopup />
        <Breadcrumb />
        <div className={'flex flex-col w-full h-full gap-y-5'}>
          <AchDetailHeaderComponent
            transactionData={currentTransaction}
            riskType={user.activeRiskType}
            alarmDomain={alarmDomain}
            disabled={disabled}
            commentCount={commentCount}
            actionModalOpen={this.actionModalOpen}
            listModalOpen={this.listModalOpen}
            commentModalOpen={this.commentModalOpen}
            users={users}
            scores={scores}
            onCloseSuccess={this.onCloseSuccess}
          />
          <div className={'flex flex-col w-full h-full'}>
            <CustomTabv2 tab={this.getTabs()} />
          </div>
          <CaseAttachmentContainerComponent
            visible={commentModalVisible}
            transaction={currentTransaction}
            domain={alarmDomain?.name}
            disabled={disabled}
            onClose={this.commentModalClose}
            setCommentCount={(count) => this.setState({ commentCount: count })}
          />
        </div>
      </div>
    );
  }

  public componentDidMount = async () => {
    const { enterComponent, user, router } = this.props;
    const params = this.getRouteParams();
    const id = `ach-transaction-${user.activeRiskType}-${params.transactionId}`;
    enterComponent({ component: ComponentName.ACH, id, disablePathCalculation: true });

    const fileName = params.fileName;
    const transactionId = params.transactionId;
    if (fileName && transactionId) {
      await FolderService.calculateAch(fileName, transactionId, router.location.pathname);
    }

    await this.fetchTransaction();
    await this.loadTransactions();
    this.startTransactionInterval();
  };

  public componentDidUpdate = async (prevProps: Props) => {
    const { router } = this.props;
    const params = this.getRouteParams();
    const prevParams = NavigationUtil.parseUrlParams(prevProps.router.params.id);
    const prevFileName = prevParams['fileName'];
    const prevTransactionId = prevParams['transactionId'];
    const currentFileName = params.fileName;
    const currentTransactionId = params.transactionId;

    if (prevFileName !== currentFileName || prevTransactionId !== currentTransactionId) {
      if (currentFileName && currentTransactionId) {
        await FolderService.calculateAch(currentFileName, currentTransactionId, router.location.pathname);
      }
    }
  };

  public componentWillUnmount = async () => {
    const { leaveComponent, clearPage } = this.props;
    clearPage();
    leaveComponent();
    clearInterval(this.transactionIntervalId);
    this.countUpdateCounter = 0;
    await this.stopTracker();
  };

  private goConfiguration = () => {
    const { alarmDomain } = this.state;
    if (alarmDomain) {
      this.props.router.navigate(`/configuration/edit/${alarmDomain.name}`);
    }
  };

  private getRouteParams = () => {
    const { router } = this.props;
    const params = NavigationUtil.parseUrlParams(router.params.id);

    const transactionId: string | null = params['transactionId'];
    const fileName: string | null = params['fileName'];

    return {
      transactionId,
      fileName,
    };
  };

  private fetchTransaction = async () => {
    const { alarmDomain } = this.state;
    const params = this.getRouteParams();
    const transactionId = params.transactionId;
    const fileName = params.fileName;

    if (!transactionId || !fileName) {
      this.setState({ loading: false });
      return;
    }

    try {
      this.setState({ loading: true });

      const transaction = await this.achService.getTransactionByFileNameAndId(fileName, transactionId);

      if (transaction) {
        const activeRuleCount = transaction.result[this.props.user.activeRiskType]?.rules?.length ?? 0;
        const transactionName = transaction.name;
        this.setState({ currentTransaction: transaction, loading: false, activeRuleCount }, async () => {
          await this.loadCaseSettings(transactionName);
          await this.getFilterFields();
          if (alarmDomain) {
            await this.startTracker();
          }
          this.subscribeToLogs(transaction);
        });
      } else {
        console.error('Transaction not found:', { transactionId, fileName });
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching transaction:', error);
      this.setState({ loading: false });
    }
  };

  private checkActionButtonsDisabled = (transaction: TransactionData) => {
    const { user } = this.props;
    const { alarmDomain } = this.state;

    if (!alarmDomain || !transaction) return;

    if (!canEditCaseDomain(alarmDomain, 'ACH')) {
      this.setState({ disabled: true });
      return;
    }

    const isAdmin = user.roles.includes('Admin') || user.role === 'Admin' || user.role === 'Root';
    if (isAdmin) {
      this.setState({ disabled: false });
      return;
    }

    let isDisabled = false;

    const result = transaction.result?.[user.activeRiskType];
    const currentAssignee = assigneeIdFromStoredValue(result?.metadata?.assignee?.id);
    if (currentAssignee !== undefined && currentAssignee !== 'System' && currentAssignee !== user.username) {
      isDisabled = true;
    }

    this.setState({ disabled: isDisabled });
  };

  private getDetailContent = () => {
    const {
      currentTransaction,
      transactions,
      totalRecord,
      rows,
      currentPage,
      sort,
      scores,
      activeRuleCount,
      alarmDomain,
      transactionUpdate,
      transactionDataLoading,
    } = this.state;
    const { user } = this.props;

    if (currentTransaction == undefined) {
      return <CustomLoading />;
    }

    return (
      <div className={'flex flex-col h-full w-full overflow-y-scroll p-5 gap-y-5 max-h-[calc(100vh-16rem)]'}>
        <div className={'grid grid-cols-1'}>
          <CaseDetailIndicatorPanelComponent
            scores={scores}
            transactionData={currentTransaction}
            alarmDomain={alarmDomain}
            activeRuleCount={activeRuleCount}
            riskType={user.activeRiskType}
          />
        </div>
        <div className={'grid grid-cols-1 lg:grid-cols-2 gap-x-5 gap-y-5'}>
          <CaseDetailSummaryPanelComponent
            key={`summary-panel-${currentTransaction?.id}-${transactionUpdate}`}
            transactionData={currentTransaction}
            riskType={user.activeRiskType}
          />
          {this.getGraphGroups().length > 0 && this.getAchDomain() ? (
            <CaseGraphComponent
              transaction={currentTransaction.name}
              key={`graph-${currentTransaction?.id}`}
              domain={this.getAchDomain()!}
              groups={this.getGraphGroups()}
              transactionAmountField={this.getAchDomain()?.transactionAmountField}
              currencyConfiguration={this.getAchDomain()?.transactionCurrencyField}
              filter={this.getGraphFilter()}
              riskType={user.activeRiskType}
            />
          ) : (
            <div
              style={{ boxShadow: '2px 2px 15px 0px #0000000D' }}
              className={'flex w-full flex-col bg-[#FFFFFF] border-[#E0E4E8] border-[1px] rounded-[10px] h-[416px] overflow-hidden'}
            >
              <span className='flex flex-row h-[50px] shrink-0 w-full justify-between items-center px-5 border-b-[1px] border-[#E0E4E8] rounded-t-[10px] bg-[#F9FAFB]'>
                <div className={'text-primary'}>{LanguageUtil.get({ id: 'pages.case.detail.header.graphAnalytics' })}</div>
              </span>
              <div className={'flex flex-col items-center justify-center w-full min-h-[364px] bg-white gap-5 px-5 py-5 rounded-b-[10px]'}>
                <div className={'flex items-center w-40 h-40 justify-center rounded-full bg-secondary'}>
                  <section className={'flex items-center w-32 h-32 justify-center rounded-full bg-white drop-shadow'}>
                    <Icon icon={'sidebar-graph'} className={'text-[#728EFF]'} size={45} />
                  </section>
                </div>
                <section className={'flex flex-col items-center justify-center gap-y-2 select-none'}>
                  <div className={'text-f-black-2 text-center'}>
                    {LanguageUtil.get({ id: 'pages.case.detail.header.graphnotConfiguredYet' })}
                    <strong className={'cursor-pointer'} onClick={this.goConfiguration}>
                      {LanguageUtil.get({ id: 'pages.case.detail.header.click' })}
                    </strong>
                    <div> {LanguageUtil.get({ id: 'pages.case.detail.header.toConfigure' })}</div>
                  </div>
                </section>
              </div>
            </div>
          )}
        </div>
        {alarmDomain && (
          <div className={'grid grid-cols-2 gap-y-5 gap-x-5'}>
            {alarmDomain.panels
              ?.filter((p) => p.enabled)
              .map((panel, index) => {
                switch (panel.type) {
                  case CasePanelType.CHART:
                    return (
                      <CaseDetailChartPanelComponent
                        key={`${panel.title ?? ''}${index}-${transactionUpdate}`}
                        transactionData={currentTransaction}
                        panel={panel as CaseChartPanel}
                      />
                    );
                  default:
                    return (
                      <AchDetailVariablePanelComponent
                        key={(panel.title ?? '') + index}
                        index={index}
                        panel={panel as CaseFieldPanel}
                        transactionData={currentTransaction}
                      />
                    );
                }
              })}
          </div>
        )}
        <div className={'grid grid-cols-1 gap-x-5'}>
          <ItemToolsMenu
            component={ComponentName.ACH}
            importVisible={false}
            componentLabel={`ACH Activity ${ValueUtil.parseNumber(totalRecord)} transaction(s)`}
            exportFunc={this.exportTransactionData}
            exportVisibleAlways
            acceptFunc={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.closeBulk(e, 'NOT_FRAUD');
            }}
            rejectFunc={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.closeBulk(e, 'FRAUD');
            }}
            acceptVisible={alarmDomain != undefined && canPerformBulkClose(user.username, alarmDomain, 'ACH')}
            rejectVisible={alarmDomain != undefined && canPerformBulkClose(user.username, alarmDomain, 'ACH')}
            onChangeFilter={this.onChangeFilter}
            acceptLabel={
              user?.activeRiskType == 'fraud'
                ? LanguageUtil.get({ id: 'common.label.notFraud', defaultMessage: 'Not Fraud' })
                : LanguageUtil.get({ id: 'common.label.compliant', defaultMessage: 'Compliant' })
            }
            rejectLabel={
              user?.activeRiskType == 'fraud'
                ? LanguageUtil.get({ id: 'common.label.fraud', defaultMessage: 'Fraud' })
                : LanguageUtil.get({ id: 'common.label.inCompliant', defaultMessage: 'Incompliant' })
            }
            preferences={{
              columnPreferencesVisible: false,
            }}
          />
          <div className={'flex flex-col w-full h-full overflow-y-hidden'}>
            <AchTransactionsActivityComponent
              transactions={transactions}
              selectedAlarmDomain={alarmDomain}
              total={totalRecord}
              rows={rows}
              update={transactionUpdate}
              paginationFixed={true}
              onPageChange={this.onPageChange}
              currentPage={currentPage}
              onSortChange={this.onSortChange}
              onChangeFilter={this.onChangeFilter}
              openInNewPage
              selectedTransactionId={currentTransaction.id}
              loading={transactionDataLoading}
              multiple
              sort={sort}
              filterKey={currentTransaction.variables?.fileName}
              fileName={this.getRouteParams().fileName || undefined}
            />
          </div>
        </div>
      </div>
    );
  };

  private actionModalOpen = () => {};

  private listModalOpen = () => {};

  private loadCaseSettings = async (transactionName: string) => {
    const { currentTransaction } = this.state;
    try {
      const caseSettings = await this.caseSettingsService.getByChannel(transactionName);
      if (caseSettings) {
        const userQuery: query.Query = query.QueryBuilder.select()
          .from(CollectionNames.USERS)
          .where(empty())
          .select('username', 'firstName', 'lastName')
          .build();
        const users: User[] = await this.repository.findMany(userQuery);
        this.setState({ alarmDomain: caseSettings, users }, async () => {
          await this.stopTracker();
          await this.startTracker();
          if (currentTransaction) {
            this.checkActionButtonsDisabled(currentTransaction);
          }
          await this.getScores();
        });
      }
    } catch (error) {
      console.error('Error loading case settings:', error);
    }
  };

  private getScores = async () => {
    const { currentTransaction, alarmDomain } = this.state;
    if (currentTransaction && alarmDomain) {
      const keyField: string = alarmDomain.keyField;
      const keyValue = currentTransaction.variables[keyField];
      if (keyField && keyValue != undefined && keyValue != null) {
        try {
          const scores = await this.achService.getScores(alarmDomain.name, {
            key: keyField,
            keyValue: keyValue,
          });
          this.setState({ scores: scores ?? {} });
        } catch (error) {
          console.error('[ACH Detail] Error getting scores:', error);
          this.setState({ scores: {} });
        }
      }
    }
  };

  private getGraphGroups = (): CaseGraphField[] => {
    const { alarmDomain } = this.state;
    if (!alarmDomain) return [];

    const arr: CaseGraphField[] = [];
    alarmDomain.graphConfiguration.forEach((f) => {
      if (f.enabled) {
        arr.push({ label: f.field, field: f.field, icon: f.color, dataType: f.dataType ?? DataType.STRING });
      }
    });
    return arr;
  };

  private getAchDomain = (): CaseSettings | undefined => {
    return this.state.alarmDomain;
  };

  private getGraphFilter = (): Filter => {
    const { currentTransaction, alarmDomain, filter } = this.state;

    if (!currentTransaction) {
      return filter || empty();
    }

    if (alarmDomain && alarmDomain.keyField) {
      const keyValue = currentTransaction.variables?.[alarmDomain.keyField];
      if (keyValue != undefined && keyValue != null) {
        const keyFilter: MatchFilter<string> = {
          filterType: 'MatchFilter',
          key: `variables.${alarmDomain.keyField}.keyword`,
          value: keyValue,
          type: 'eq',
        };

        if (filter && filter.filterType === 'ConditionalFilter') {
          const conditionalFilter = filter as ConditionalFilter;
          return {
            filterType: 'ConditionalFilter',
            type: 'and',
            filters: [keyFilter, ...conditionalFilter.filters],
          } as ConditionalFilter;
        } else if (filter) {
          return {
            filterType: 'ConditionalFilter',
            type: 'and',
            filters: [keyFilter, filter],
          } as ConditionalFilter;
        } else {
          return keyFilter;
        }
      }
    }

    const transactionIdFilter: MatchFilter<string> = {
      filterType: 'MatchFilter',
      key: 'id.keyword',
      value: currentTransaction.id,
      type: 'eq',
    };

    if (filter && filter.filterType === 'ConditionalFilter') {
      const conditionalFilter = filter as ConditionalFilter;
      return {
        filterType: 'ConditionalFilter',
        type: 'and',
        filters: [transactionIdFilter, ...conditionalFilter.filters],
      } as ConditionalFilter;
    } else if (filter) {
      return {
        filterType: 'ConditionalFilter',
        type: 'and',
        filters: [transactionIdFilter, filter],
      } as ConditionalFilter;
    } else {
      return transactionIdFilter;
    }
  };

  protected getTabs = () => {
    const { currentTransaction } = this.state;
    return [
      {
        key: 'Information',
        label: LanguageUtil.get({ id: 'common.label.information', defaultMessage: 'Information' }),
        content: this.getDetailContent(),
      },
      {
        key: 'Audit Log',
        label: LanguageUtil.get({ id: 'common.label.audit', defaultMessage: 'Audit Log' }),
        content: <CaseAuditComponent transaction={currentTransaction} />,
      },
    ];
  };

  private closeBulk = async (e: MouseEvent<HTMLElement>, type: 'FRAUD' | 'NOT_FRAUD') => {
    const { alarmDomain, selectedAdditionalCaseSettings, reason } = this.state;
    const {
      component: { selectedComponentIds },
      user,
    } = this.props;

    if (!selectedComponentIds || selectedComponentIds.length === 0) {
      MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'common.label.warning', defaultMessage: 'Warning' }),
        detail: <div>{LanguageUtil.get({ id: 'messages.warning.noItemSelected', defaultMessage: 'Please select at least one item' })}</div>,
      });
      return;
    }

    const selectedIds: CloseCaseBulkActionOperation[] = selectedComponentIds.map((component: TransactionData) => ({
      id: component.id,
      index: component._index,
    }));
    const domain = selectedAdditionalCaseSettings ?? alarmDomain;
    if (!domain) return;
    if (!canPerformBulkClose(user.username, domain, 'ACH')) {
      return;
    }

    const target = e.currentTarget || (e.target as HTMLElement);
    customConfirm({
      target: target,
      rejectIcon: <Icon icon={'close'} className={'text-[#1873D5]'} size={20} />,
      acceptIcon: <Icon icon={'check'} className={'text-white'} size={20} />,
      rejectLabel: LanguageUtil.get({ id: 'common.label.cancel' }),
      acceptLabel: LanguageUtil.get({ id: 'common.label.okay' }),
      accept: async () => {
        const riskType = user.activeRiskType;
        const _type =
          type == 'FRAUD'
            ? riskType == 'fraud'
              ? TransactionReason.FRAUD
              : TransactionReason.IN_COMPLIANT
            : riskType == 'fraud'
              ? TransactionReason.NOT_FRAUD
              : TransactionReason.COMPLIANT;
        await this.achService.closeBulkCase(user, domain.name, selectedIds, _type, this.state.reason, domain).then(async () => {
          MessageUtil.success({
            summary: LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' }),
            detail: <div>{LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' })} closed</div>,
          });
          this.props.setSelectedItems([]);
          await this.loadTransactions();
          await this.fetchTransaction();
        });
        this.setState({ reason: undefined });
      },
      reject: async () => {
        this.setState({ reason: undefined });
      },
      message: (
        <FormicaSearchSelectBox
          placeholder={LanguageUtil.get({ id: 'common.input.placeholder.reason', defaultMessage: 'Reason' })}
          options={this.prepareReasonSelectBox(type)}
          value={reason}
          className={'w-full'}
          onChange={(e: FormicaSelectBoxItem) => this.setState({ reason: e.value })}
        />
      ),
    });
  };

  private prepareReasonSelectBox = (type: string): any => {
    const { alarmDomain, selectedAdditionalCaseSettings } = this.state;
    const { user } = this.props;
    const riskType = user.activeRiskType;
    const _type = type == 'FRAUD' ? (riskType == 'fraud' ? 'FRAUD' : 'IN_COMPLIANT') : riskType == 'fraud' ? 'NOT_FRAUD' : 'COMPLIANT';
    const domain = selectedAdditionalCaseSettings ?? alarmDomain;
    return domain?.closeCodes
      .filter((r) => r.status == _type)
      .map((reason: AlarmCloseCode) => {
        return {
          label: reason.code,
          value: reason.code,
        };
      });
  };

  private onPageChange = (page: number, rows: number) => {
    this.setState({ rows, currentPage: page }, () => {
      this.restartTransactionInterval();
    });
  };

  private onSortChange = (sort: Order[]) => {
    this.setState({ sort }, () => {
      this.restartTransactionInterval();
    });
  };

  private onChangeFilter = (filter: Filter) => {
    this.setState({ filter }, () => {
      this.restartTransactionInterval();
    });
  };

  private startTransactionInterval = async () => {
    await this.onTransactionInterval();
    this.transactionIntervalId = setInterval(this.onTransactionInterval, 10_000);
  };

  private restartTransactionInterval = () => {
    clearInterval(this.transactionIntervalId);
    this.startTransactionInterval();
  };

  private onTransactionInterval = async () => {
    const { currentTransaction, scores, transactionDataLoading, alarmDomain, transactions } = this.state;
    const { user } = this.props;
    const params = this.getRouteParams();
    const transactionId = params.transactionId;
    const fileName = params.fileName;

    if (!transactionId || !fileName || !currentTransaction) return;

    try {
      const selectQuery = QueryBuilder.select().where(eq('id.keyword', transactionId)).limit(1).build();

      const result = await this.achService.getTransactionsByFileName(fileName, selectQuery);

      if (result.data && result.data.length > 0) {
        let transaction = result.data.find((t: TransactionData) => t.id === transactionId);

        if (!transaction && result.data.length > 0) {
          transaction = result.data[0];
        }

        if (transaction) {
          if (currentTransaction == undefined && transaction != undefined) {
            this.subscribeToLogs(transaction);
          }
          const currentStatus = currentTransaction.result[user.activeRiskType]?.status;
          const newStatus = transaction.result[user.activeRiskType]?.status;
          const statusChanged = currentStatus !== newStatus;
          if (!_.isEqual(transaction, currentTransaction) || statusChanged) {
            const activeRuleCount = transaction.result[user.activeRiskType]?.rules?.length ?? 0;
            this.setState({ currentTransaction: transaction, activeRuleCount, transactionDataLoading: false }, () => {
              this.getScores();
              if (transaction) {
                this.checkActionButtonsDisabled(transaction);
              }
            });
          }
        }
      }

      const transactionsQuery = this.getTransactionSubscriptionQuery();
      const transactionsResult = await this.achService.getTransactionsByFileName(fileName, transactionsQuery);

      if (!_.isEqual(transactionsResult.data, transactions)) {
        this.setState({ transactions: transactionsResult.data, transactionDataLoading: false });
      }

      if (Object.keys(scores).length == 0 && currentTransaction && alarmDomain) {
        const keyField: string = alarmDomain.keyField;
        const keyValue = currentTransaction.variables[keyField];
        if (keyField && keyValue != undefined && keyValue != null) {
          await this.getScores();
        }
      }

      this.countUpdateCounter++;
      if (this.countUpdateCounter >= 5) {
        await this.fetchCount();
        this.countUpdateCounter = 0;
      }

      if (transactionDataLoading) {
        this.setState({ transactionDataLoading: false });
      }
    } catch (error) {
      console.error('Error in transaction interval:', error);
    }
  };

  private getTransactionSubscriptionQuery = () => {
    const { currentPage, rows, filter, sort } = this.state;
    const params = this.getRouteParams();
    const fileName = params.fileName;

    if (!fileName) {
      return QueryBuilder.select().where(empty()).build();
    }

    return this.achService.buildTransactionQuery(fileName, currentPage, rows, sort, filter);
  };

  private loadTransactions = async () => {
    const params = this.getRouteParams();
    const fileName = params.fileName;

    if (!fileName) return;

    try {
      this.setState({ transactionDataLoading: true });
      const query = this.getTransactionSubscriptionQuery();
      const result = await this.achService.getTransactionsByFileName(fileName, query);
      this.setState({
        transactions: result.data,
        totalRecord: result.count,
        transactionDataLoading: false,
      });
    } catch (error) {
      console.error('Error loading transactions:', error);
      this.setState({ transactionDataLoading: false });
    }
  };

  private fetchCount = async () => {
    const { totalRecord } = this.state;
    const params = this.getRouteParams();
    const fileName = params.fileName;

    if (!fileName) return;

    try {
      const _query = this.getTransactionSubscriptionQuery();
      const fetchQuery = QueryBuilder.select()
        .where(_query.filter || empty())
        .build();

      const result = await this.achService.getTransactionsByFileName(fileName, fetchQuery);
      if (totalRecord != result.count) {
        this.setState({ totalRecord: result.count });
      }
    } catch (e) {
      console.error('Error fetching count:', e);
    }
  };

  private getFilterFields = async (saveFilter: boolean = true) => {
    const { currentTransaction } = this.state;
    const fileName = currentTransaction?.variables?.fileName;
    if (fileName) {
      this.applyDefaultFilter();

      await FilterUtil.getCaseFields(currentTransaction.name, saveFilter);
      const { page } = store.getState();
      const parsedFilter = FilterUtil.parse(page.filter.filter);
      this.setState({ filter: parsedFilter });
    }
  };

  private applyDefaultFilter = () => {
    const { attributes, changePageFilter, user } = this.props;
    if (!attributes?.filters) {
      return;
    }

    const { page } = store.getState();
    const defaultFilter: DefaultFilter | undefined = DefaultFilterUtil.find(attributes.filters, {
      component: ComponentName.ACH,
      riskType: user.activeRiskType,
    });

    if (!defaultFilter) {
      return;
    }

    const newFilterFields = defaultFilter.filter.filter.fields.filter(
      (field: any) => !page.filter.filter.fields.some((pageField: any) => pageField.field == field.field),
    );

    if (newFilterFields.length > 0) {
      page.filter.filter.fields.push(...newFilterFields);
      changePageFilter({
        filter: page.filter.filter,
        items: [],
      });
    }
  };

  private exportTransactionData = () => {
    const {
      component: { selectedComponentIds },
    } = this.props;
    const { currentTransaction } = this.state;
    const fileName = currentTransaction?.variables?.fileName;

    if (!fileName) return;

    const query = this.getTransactionSubscriptionQuery();
    const SELECTED_IDS_THRESHOLD = 100;
    if (selectedComponentIds.length > 0 && selectedComponentIds.length <= SELECTED_IDS_THRESHOLD) {
      const selectedIds = selectedComponentIds.map((component: TransactionData) => component.id);
      query.filter = and(
        eq('variables.fileName.keyword', fileName),
        inside('id.keyword', selectedIds),
      );
    } else {
      query.filter = eq('variables.fileName.keyword', fileName);
    }

    (query as any).source = ``;
    // ACH export'u için size/limit olmayacak
    delete (query as any).top;
    delete (query as any).limit;
    delete (query as any).offset;
    delete (query as any).skip;

    const payload: TransactionDataExportJob = {
      type: 'ACH_DATA_EXPORT',
      transaction: currentTransaction.name,
      query,
      timestamp: moment().valueOf(),
      status: 'PENDING',
      extension: 'ach',
      path: '',
    };
    this.achService.exportTransactions(payload);
    MessageUtil.success({
      summary: LanguageUtil.get({ id: 'common.label.export', defaultMessage: 'Export' }),
      detail: <div>{LanguageUtil.get({ id: 'messages.success.exportScheduled', defaultMessage: 'Export scheduled' })}</div>,
    });
  };

  private commentModalOpen = () => {
    this.setState({ commentModalVisible: true });
  };

  private commentModalClose = () => {
    this.setState({ commentModalVisible: false });
  };

  private onCloseSuccess = async () => {
    await this.fetchTransaction();
  };

  private startTracker = async () => {
    const { currentTransaction, alarmDomain } = this.state;
    const params = this.getRouteParams();
    const fileName = params.fileName;
    const transactionId = params.transactionId;

    if (!currentTransaction || !alarmDomain || !fileName || !transactionId) return;

    const transactionName = currentTransaction.name;

    const alarmDomainQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).where(eq('name', alarmDomain.name)).build();

    const transactionQuery: query.SelectQuery = query.QueryBuilder.select()
      .from(CollectionNames.TRANSACTIONS)
      .where(or(eq('id', transactionName), ...(alarmDomain.additionalChannels?.map((c) => eq('name', c.channel)) || [])))
      .build();

    const ruleQuery: query.SelectQuery = query.QueryBuilder.select()
      .from(CollectionNames.RULES)
      .where(eq('workflow.children.value.name', transactionName))
      .select('name', 'description', 'workflow.children.value.name', 'riskType')
      .build();

    const userQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.USERS).where(empty()).select('username', 'firstName', 'lastName').build();

    this.alarmDomainSubscription = subscribe.Formica.subscribe(CollectionNames.CASE_SETTINGS, alarmDomainQuery);
    this.transactionSubscription = subscribe.Formica.subscribe(CollectionNames.TRANSACTIONS, transactionQuery);
    this.ruleSubscription = subscribe.Formica.subscribe(CollectionNames.RULES, ruleQuery);
    this.userSubscription = subscribe.Formica.subscribe(CollectionNames.USERS, userQuery);

    this.computation = subscribe.Tracker.autorun(this.tracker, [
      this.alarmDomainSubscription,
      this.transactionSubscription,
      this.ruleSubscription,
      this.userSubscription,
    ]);
  };

  private stopTracker = async () => {
    await this.transactionSubscription?.stop();
    await this.alarmDomainSubscription?.stop();
    await this.ruleSubscription?.stop();
    await this.userSubscription?.stop();
    await this.logSubscription?.stop();
    await this.computation?.stop();
  };

  private tracker = async () => {
    const { currentTransaction, alarmDomain, transactionUpdate } = this.state;

    if (!currentTransaction || !alarmDomain) return;

    if (this.alarmDomainSubscription?.ready() && this.transactionSubscription?.ready() && this.ruleSubscription?.ready() && this.userSubscription?.ready()) {
      const alarmDomainQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).where(eq('name', alarmDomain.name)).build();
      const userQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.USERS).where(empty()).select('username', 'firstName', 'lastName').build();

      const updatedAlarmDomain: CaseSettings | undefined = await this.repository.find(alarmDomainQuery);
      const users: User[] = await this.repository.findMany(userQuery);

      if (updatedAlarmDomain && !_.isEqual(updatedAlarmDomain, alarmDomain)) {
        this.setState({ alarmDomain: updatedAlarmDomain, users }, () => {
          this.getFilterFields();
          if (currentTransaction) {
            this.checkActionButtonsDisabled(currentTransaction);
          }
        });
      } else {
        this.setState({ users }, () => {
          if (currentTransaction) {
            this.checkActionButtonsDisabled(currentTransaction);
          }
        });
      }
      this.setState({ transactionUpdate: transactionUpdate + 1 });
    }
  };

  private subscribeToLogs = (currentTransaction: TransactionData) => {
    if (this.logSubscription != undefined) return;
    const logQuery = query.QueryBuilder.select()
      .where(
        or(
          and(neq('type', 'TAGGED_FIELD'), eq('transactionId', currentTransaction.id)),
          and(
            eq('type', 'TAGGED_FIELD'),
            neq('transactionId', currentTransaction.id),
            eq('channel', currentTransaction.name),
            or(
              ...Object.entries(currentTransaction.variables || {})
                .filter(([key, value]) => value == null || typeof value != 'object')
                .map(([key, value]) => {
                  return and(eq('taggedField', key), eq('taggedValue', value));
                }),
            ),
          ),
        ),
      )
      .limit(1000)
      .orderBy({
        field: 'timestamp',
        operator: 'DESC',
      })
      .build();
    this.logSubscription = subscribe.Formica.subscribe(`case_event_log_${NavigationUtil.getTenant()}_*`, logQuery, undefined, 'elasticsearch');
  };
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user as User,
  page: state.page as PageState,
  component: state.component as ComponentState,
  case: state.case as CaseState,
  attributes: state.auth.attributes as UserSystemAttributes,
});

const mapDispatchToProps = {
  enterComponent,
  leaveComponent,
  clearPage,
  changePageFilter,
  changeCaseColumns,
  setAttribute,
  setSelectedItems,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  users: User[] = [];
  disabled: boolean = false;
  currentTransaction: TransactionData | undefined;
  transactions: TransactionData[] = [];
  loading = true;
  transactionDataLoading: boolean = true;
  totalRecord: number = 0;
  currentPage: number = 1;
  rows: number = 10;
  sort: Order[] = [];
  filter: Filter = empty();
  scores: Record<string, number> = {};
  activeRuleCount: number = 0;
  alarmDomain: CaseSettings | undefined;
  transactionUpdate: number = 0;
  commentModalVisible: boolean = false;
  commentCount: number = 0;
  selectedAdditionalCaseSettings: CaseSettings | undefined;
  reason: string | undefined;
}

export default withFormica(connector(AchDetailComponent));
